import { useCallback, useEffect, useState } from "react";
import authInstance from '../utilities/axios/authInstance';
import { createMessage } from "../utilities/utilities";

const useDashboardStats = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState({
        show: false,
        text: '',
        variant: 'danger'
    });

    const handleMessage = (text, variant) => {
        setErrorMessage(createMessage(text, variant));
    }

    const fetchStats = useCallback(async () => {
        setLoading(true);

        try {
            const response = await authInstance.get('dashboard/summary-statistics');
            setStats(response.data);
            setErrorMessage({
                show: false,
                message: '',
                variant: ''
            });
        } catch (err) {
            const formattedError = handleMessage(err);
            setErrorMessage({
                show: true,
                message: formattedError.text,
                variant: 'danger'
            });
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchStats();
    }, [fetchStats]);

    return {
        stats,
        loading,
        errorMessage,
        setErrorMessage,
        refresh: fetchStats
    }
}

export default useDashboardStats;